<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编码" prop="toolNo">
            <el-input v-model.trim="model.toolNo" placeholder="请输入编码"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="toolName">
            <el-input v-model.trim="model.toolName" placeholder="请输入名称"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="型号">
            <el-input v-model.trim="model.toolModel" placeholder="请输入型号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类别" prop="toolTypeName">
            <el-input v-model="model.toolTypeName" placeholder="请选择类别" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.toolTypeSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="领用人" prop="receiverName">
            <el-input v-model="model.receiverName" placeholder="请选择领用人" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.userSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="领用时间">
            <el-date-picker
                v-model="model.receiveTime"
                style="width: 100%"
                type="datetime"
                placeholder="选择完工时间"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model.trim="model.note" type="textarea" autosize placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <tool-type-select ref="toolTypeSelect" @select="selectToolType"/>
    <user-select ref="userSelect" @select="selectUser"/>
  </el-dialog>
</template>

<script>
  import ToolTypeSelect from "@/views/information/ToolManagement/ToolType/ToolTypeSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  export default {
    name: "ToolEdit",
    components: {UserSelect, ToolTypeSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        disabled:false,
        model: {
          pkid: "",
          toolNo: "",
          toolTypeId: "",
          toolTypeName: "",
          toolName: "",
          toolModel: "",
          note: "",
          status: "",
          receiverId: "",
          receiverName: "",
          receiveTime: "",
        },
        ruleValidate: {
          toolNo: { required: true, message: "不能为空", trigger: "blur" },
          toolName: { required: true, message: "不能为空", trigger: "blur" },
          toolTypeName: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        }
      },
      getData(pkid) {
        this.$http.get("basic", `tools/${pkid}`).then((res) => {
          console.log(res);
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
          }
        });
      },
      selectToolType(row) {
        console.log(row);
        this.model.toolTypeId = row.id;
        this.model.toolTypeName = row.label;
      },
      selectUser(row) {
        console.log(row);
        this.model.receiverId = row.systemUserID;
        this.model.receiverName = row.employeeName;
      },

      handleSubmit() {
        if (this.model.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "tools", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "tools", this.model)
              .then((resp) => {
                this.submitLoading = false;
                this.dialogVisible = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
